import type { DiagramProps } from '@/lib/scad-feature-types';
import { D } from './DiagramStyles';

/** Shows how $fn affects circle resolution */
export function FnDiagram({ values }: DiagramProps) {
  const fnValue = values.fn ?? 50;
  const examples = [
    { fn: 4,  label: '$fn=4' },
    { fn: 6,  label: '$fn=6' },
    { fn: 12, label: '$fn=12' },
    { fn: 32, label: '$fn=32' },
  ];
  const cx = [40, 95, 155, 215];
  const cy = 70;
  const r = 30;

  function hexPoints(n: number, x: number, y: number, radius: number): string {
    return Array.from({ length: n }, (_, i) => {
      const a = (i * 2 * Math.PI) / n - Math.PI / 2;
      return `${(x + radius * Math.cos(a)).toFixed(1)},${(y + radius * Math.sin(a)).toFixed(1)}`;
    }).join(' ');
  }

  return (
    <svg viewBox="0 0 280 150" width="100%" style={{ display: 'block' }} aria-label="$fn resolution diagram">
      {examples.map((ex, i) => {
        const isCurrent = fnValue >= ex.fn && (i === examples.length - 1 || fnValue < examples[i + 1].fn);
        return (
          <g key={ex.fn}>
            <polygon points={hexPoints(ex.fn, cx[i], cy, r)}
                     fill={D.GEO_FILL} stroke={isCurrent ? '#f59e0b' : D.GEO_STROKE}
                     strokeWidth={isCurrent ? 2 : 1.2} />
            <text x={cx[i]} y={cy + r + 14} fontSize="9" fontFamily="monospace"
                  fill={isCurrent ? '#f59e0b' : 'currentColor'}
                  opacity={isCurrent ? '0.9' : '0.5'} textAnchor="middle">
              {ex.label}
            </text>
          </g>
        );
      })}

      {/* Current value indicator */}
      <text x="140" y="142" fontSize="9" fontFamily="monospace"
            fill="currentColor" opacity="0.45" textAnchor="middle">
        higher $fn = smoother curves, more geometry
      </text>
    </svg>
  );
}
